var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"bcx-transition-fade"}},[_c(_setup.BCXPanel,{staticClass:"bc-settings-popup",style:(_setup.style),attrs:{"primary-theme":""},on:{"close-panel":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }